import {
    createRegisterableComponentWithData,
    CurationAndCurationMetadataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { TrendingArticles } from './TrendingArticles'

export const TrendingArticlesRegistration = createRegisterableComponentWithData(
    'trending-articles',
    CurationAndCurationMetadataLoader,
    (
        props: {
            displayPublicationDate?: boolean
            renderBasicTeaser?: boolean
            displayKicker?: boolean
            hideBorder?: boolean
        },
        data,
        { onEvent },
    ) => {
        return (
            <TrendingArticles
                data={data}
                onEvent={onEvent}
                displayPublicationDate={props.displayPublicationDate}
                renderBasicTeaser={props.renderBasicTeaser}
                displayKicker={props.displayKicker}
                hideBorder={props.hideBorder}
            />
        )
    },
)
